<template>
  <v-container id="system" fluid tag="section">
    <v-row>
      <router-view />
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "System",
  data() {
    return {};
  },
};
</script>
